import { __assign, __rest } from "tslib";
import { StreamType } from '../types';
import { actionKey } from './constants';
import { createAction } from 'redux-actions';
export var STREAM__WITH_CURSOR__INITIALIZE = "".concat(actionKey, "__INITIALIZE");
export var STREAM__WITH_CURSOR__SET_CURSOR = "".concat(actionKey, "__SET_CURSOR");
export var STREAM__WITH_CURSOR__FETCH = "".concat(actionKey, "__FETCH");
export var STREAM__WITH_CURSOR__FETCH_SUCCESS = "".concat(actionKey, "__FETCH_SUCCESS");
export var STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE = "".concat(actionKey, "__FETCH_SUCCESS_DEDUPE");
export var STREAM__WITH_CURSOR__INSERT_ITEMS = "".concat(actionKey, "__INSERT_ITEMS");
export var initialize = function (_a) {
    var cursor = _a.cursor, prevCursor = _a.prevCursor, baseInitializeParams = __rest(_a, ["cursor", "prevCursor"]);
    return (__assign(__assign({}, baseInitializeParams), { type: STREAM__WITH_CURSOR__INITIALIZE, streamType: StreamType.WITH_CURSOR, cursor: cursor, prevCursor: prevCursor }));
};
export var setCursor = function (streamId, cursor) { return ({
    type: STREAM__WITH_CURSOR__SET_CURSOR,
    streamId: streamId,
    cursor: cursor,
}); };
export var fetch = function (streamId) { return ({
    type: STREAM__WITH_CURSOR__FETCH,
    streamId: streamId,
}); };
export var fetchAll = function (streamId) { return ({
    type: STREAM__WITH_CURSOR__FETCH,
    streamId: streamId,
    all: true,
}); };
export var fetchSuccess = function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities, hasMore = _a.hasMore, total = _a.total, cursor = _a.cursor;
    return ({
        type: STREAM__WITH_CURSOR__FETCH_SUCCESS,
        streamId: streamId,
        items: items,
        entities: entities,
        hasMore: hasMore,
        total: total,
        cursor: cursor,
    });
};
export var fetchSuccessDeduped = function (payload) { return (__assign({ type: STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE }, payload)); };
export var insertItemsAtOffsetAndSetCursor = function (_a) {
    var streamId = _a.streamId, items = _a.items, offset = _a.offset, entities = _a.entities, newCursor = _a.newCursor;
    return ({
        type: STREAM__WITH_CURSOR__INSERT_ITEMS,
        streamId: streamId,
        items: items,
        offset: offset,
        entities: entities,
        newCursor: newCursor,
    });
};
export var fetchPrevious = createAction("".concat(actionKey, "__FETCH_PREVIOUS"), function (streamId) { return ({ streamId: streamId }); });
export var fetchPreviousSuccess = createAction("".concat(actionKey, "__FETCH_PREVIOUS_SUCCESS"), function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities, hasLess = _a.hasLess, prevCursor = _a.prevCursor, dedupeFunction = _a.dedupeFunction;
    return ({
        streamId: streamId,
        items: items,
        entities: entities,
        hasLess: hasLess,
        prevCursor: prevCursor,
        dedupeFunction: dedupeFunction,
    });
});
export var fetchAllSuccess = createAction("".concat(actionKey, "__FETCH_All_SUCCESS"), function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities;
    return ({
        streamId: streamId,
        items: items,
        entities: entities,
    });
});
export var emptyStream = createAction("".concat(actionKey, "__EMPTY"), function (streamId) { return ({ streamId: streamId }); });
export var resetStream = createAction("".concat(actionKey, "__RESET"), function (streamId) { return ({ streamId: streamId }); });
export { deleteItems, deleteStream, fetchFailure, replaceItem, markAsFetching, } from '../base/actions';
//# sourceMappingURL=actions.js.map